import type { ElementType, ReactNode } from 'react'
import { cx } from 'src/utils/cx'

type CustomHeroTitleWithDescriptionProps = {
  title: ReactNode
  description?: ReactNode
  className?: string
  titleComponent?: ElementType
  descComponent?: ElementType
  size?: 'normal' | 'small'
}

export const SiteNameWithDescription = (
  props: Pick<
    CustomHeroTitleWithDescriptionProps,
    'className' | 'descComponent'
  >,
) => {
  return (
    <CustomHeroTitleWithDescription
      title="PixAI"
      description="The AI Character Engine"
      {...props}
    />
  )
}

export const CustomHeroTitleWithDescription = (
  props: CustomHeroTitleWithDescriptionProps,
) => {
  const TitleComp = props.titleComponent ?? 'div'
  const SubtitleComp = props.descComponent ?? 'h2'

  return (
    <div className={cx('py-2 text-center mt-5', props.className)}>
      <TitleComp
        className={cx(
          'font-pixai-rounded',
          'relative',
          props.size === 'small' ? 'msm:text-2xl' : 'text-2xl sm:text-5xl',
        )}
      >
        {props.title}
      </TitleComp>
      {props.description && (
        <SubtitleComp
          className={cx(
            'font-medium leading-none uppercase tracking-widest',
            props.size === 'small'
              ? '-mt-2 text-xs leading-none scale-50'
              : 'text-[13px]',
          )}
        >
          <span
            className={cx(
              props.size === 'small' &&
                'inline-flex flex-col items-center w-0 whitespace-nowrap',
            )}
          >
            {props.description}
          </span>
        </SubtitleComp>
      )}
    </div>
  )
}
